import React, { FunctionComponent, ReactNode } from "react";

import { CheckboxProps } from "@material-ui/core/Checkbox";

import { RawCheckbox } from "./RawCheckbox";
import { FormikCheckbox } from "./FormikCheckbox";

type IProps = CheckboxProps & {
  name?: string;
  label?: ReactNode;
  inFormik?: boolean;
};

export const Checkbox: FunctionComponent<IProps> = ({
  name,
  label,
  inFormik,
  disabled = false,
  ...props
}: IProps) => {
  return inFormik && name ? (
    <FormikCheckbox name={name} label={label} disabled={disabled} {...props} />
  ) : (
    <RawCheckbox label={label} disabled={disabled} {...props} />
  );
};
